import { format, parseISO, startOfDay } from 'date-fns';
import { GuardPayrollRecord, ConsultantPayrollRecord } from 'containers/pages/payrollReport/types';

/**
 * Groups guard patrol records by their WorkDate.
 * The cutOffHour determines which date a shift belongs to:
 * shifts starting before the cutoff hour are grouped with the previous day.
 */
export const groupPatrolsByShiftDate = (
  records: GuardPayrollRecord[],
  cutOffHour: number,
): Record<string, GuardPayrollRecord[]> => {
  const groups: Record<string, GuardPayrollRecord[]> = {};

  records.forEach((record) => {
    const startDate = new Date(record.StartTime);
    const hour = startDate.getHours();

    // If shift starts before cutoff hour, group with previous day
    let groupDate: Date;
    if (hour < cutOffHour) {
      groupDate = new Date(startDate);
      groupDate.setDate(groupDate.getDate() - 1);
    } else {
      groupDate = startDate;
    }

    const dateKey = format(startOfDay(groupDate), 'yyyy-MM-dd');
    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(record);
  });

  return groups;
};

/**
 * Groups consultant comment records by their CommentDate (normalized to midnight).
 */
export const groupCommentsByDate = (
  records: ConsultantPayrollRecord[],
): Record<string, ConsultantPayrollRecord[]> => {
  const groups: Record<string, ConsultantPayrollRecord[]> = {};

  records.forEach((record) => {
    const dateKey = format(startOfDay(parseISO(record.CommentDate)), 'yyyy-MM-dd');
    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(record);
  });

  return groups;
};
